/**
 * Rodapé de navegação compartilhado pelos steps 1 a 5.
 *
 * A ordem no DOM é sempre "Voltar" e depois o primário — leitores de tela e
 * navegação por Tab seguem essa ordem. O `StepFooter` usa `column-reverse` no
 * mobile, então visualmente o botão preenchido aparece ACIMA do "Voltar", como o
 * spec desenha em todos os passos.
 */

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { CircularProgress } from "@mui/material";

import { Button, StepFooter } from "../styled";

interface IProps {
  /** Ex.: "Próximo: Dependentes →". */
  nextLabel: string;
  onNext: () => void;
  onBack?: () => void;
  isNextDisabled?: boolean;
  /** Bloqueia os dois botões e troca o rótulo por um spinner. */
  isBusy?: boolean;
}

export function StepActions({
  nextLabel,
  onNext,
  onBack,
  isNextDisabled = false,
  isBusy = false,
}: IProps) {
  return (
    <StepFooter>
      {onBack && (
        <Button
          variant="outlined"
          onClick={onBack}
          disabled={isBusy}
          startIcon={<ChevronLeftIcon style={{ height: "20px" }} />}
        >
          Voltar
        </Button>
      )}
      <Button
        variant="contained"
        onClick={onNext}
        disabled={isNextDisabled || isBusy}
      >
        {isBusy ? (
          <CircularProgress
            color="inherit"
            size={20}
          />
        ) : (
          nextLabel
        )}
      </Button>
    </StepFooter>
  );
}
